import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=b520ad2a&scoped=true"
import script from "./DetailContent.vue?vue&type=script&lang=js"
export * from "./DetailContent.vue?vue&type=script&lang=js"
import style0 from "./DetailContent.vue?vue&type=style&index=0&id=b520ad2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b520ad2a",
  null
  
)

export default component.exports